// File: src/pages/QrKodDuzelt.js
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './YukleLinkDuzelt.css';
import QrCodeController from '../../../api/qrcode/QrCodeController';

function isValidHttpUrl(url) {
  try {
    const u = new URL(url);
    return u.protocol === 'http:' || u.protocol === 'https:';
  } catch (_) {
    return false;
  }
}

export default function YukleLinkDuzelt() {
  const navigate = useNavigate();
  const id = 2;

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [initial, setInitial] = useState(null);

  // Form state
  const [isAppLink, setIsAppLink] = useState(null); // null | true | false
  const [mainLink, setMainLink] = useState('');
  const [androidLink, setAndroidLink] = useState('');
  const [iosLink, setIosLink] = useState('');

  const handleBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    let mounted = true;
    async function load() {
      try {
        setLoading(true);
        const data = await QrCodeController.getQRCodeById(id);
        if (!mounted) return;
        setInitial(data);
        // İlk dəyərləri forma doldur
        setIsAppLink(
          typeof data.isAppLink === 'boolean' ? data.isAppLink : null
        );
        setMainLink(data.mainLink || '');
        setAndroidLink(data.androidLink || '');
        setIosLink(data.iosLink || '');
      } catch (e) {
        if (!mounted) return;
        setError(e?.response?.data?.message || e?.message || 'Məlumat yüklənmədi');
      } finally {
        if (mounted) setLoading(false);
      }
    }
    load();
    return () => { mounted = false; };
  }, [id]);

  const androidOk = useMemo(() => !androidLink || isValidHttpUrl(androidLink), [androidLink]);
  const iosOk = useMemo(() => !iosLink || isValidHttpUrl(iosLink), [iosLink]);
  const mainOk = useMemo(() => !mainLink || isValidHttpUrl(mainLink), [mainLink]);

  const canSave = useMemo(() => {
    if (isAppLink === true) {
      // ən azı linklərdən biri düzgün olsun
      return androidOk && iosOk && (androidLink || iosLink);
    }
    if (isAppLink === false) {
      return mainOk && !!mainLink;
    }
    return false; // seçim edilməyibsə
  }, [isAppLink, androidOk, iosOk, mainOk, androidLink, iosLink, mainLink]);

  const handleSave = async () => {
    try {
      setLoading(true);
      const payload = {
        id,
        isAppLink,
        mainLink: isAppLink ? '' : mainLink || '',
        androidLink: isAppLink ? (androidLink || '') : '',
        iosLink: isAppLink ? (iosLink || '') : '',
        createdAt: initial?.createdAt ?? null,
        updatedAt: new Date().toISOString(),
      };
      await QrCodeController.updateQRCode(id, payload);
      // Uğurlu saxlanış sonrası yenidən yüklə
      const fresh = await QrCodeController.getQRCodeById(id);
      setInitial(fresh);
      setIsAppLink(typeof fresh.isAppLink === 'boolean' ? fresh.isAppLink : null);
      setMainLink(fresh.mainLink || '');
      setAndroidLink(fresh.androidLink || '');
      setIosLink(fresh.iosLink || '');
      setError(null);
    } catch (e) {
      setError(e?.response?.data?.message || e?.message || 'Saxlanılarkən xəta baş verdi');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="qrduz-wrap">
      <div className="qrduz-header">
        <button className="back-button" onClick={handleBack}>Geri</button>
        <h1 className="moto-taksi-sifarish-title">Qr Kod Link Düzəlt</h1>
      </div>

      <div className="qrduz-card">
        {loading && (
          <div className="qrduz-skeleton">
            <div className="s-line w80" /><div className="s-line w60" /><div className="s-line w40" />
          </div>
        )}

        {!loading && error && (
          <div className="qrduz-error">{error}</div>
        )}

        {!loading && !error && (
          <>
            <div className="qrduz-row readonly">
              <label>ID</label>
              <div className="value">{id}</div>
            </div>

            <div className="qrduz-row">
              <label>Mobil Tətbiq Linkidir?</label>
              <div className="btn-group">
                <button
                  type="button"
                  className={`seg ${isAppLink === true ? 'active' : ''}`}
                  onClick={() => setIsAppLink(true)}
                >Bəli</button>
                <button
                  type="button"
                  className={`seg ${isAppLink === false ? 'active' : ''}`}
                  onClick={() => setIsAppLink(false)}
                >Xeyr</button>
              </div>
            </div>

            {isAppLink === true && (
              <>
                <div className="qrduz-row">
                  <label>Moto Taksi Android üçün link</label>
                  <input
                    type="url"
                    className={!androidOk ? 'invalid' : ''}
                    placeholder="https://play.google.com/store/apps/details?id=..."
                    value={androidLink}
                    onChange={(e) => setAndroidLink(e.target.value)}
                  />
                  {!androidOk && <small className="hint">Düzgün URL daxil edin</small>}
                </div>

                <div className="qrduz-row">
                  <label>Moto Taksi iPhone üçün link</label>
                  <input
                    type="url"
                    className={!iosOk ? 'invalid' : ''}
                    placeholder="https://apps.apple.com/app/idXXXXXXXXX"
                    value={iosLink}
                    onChange={(e) => setIosLink(e.target.value)}
                  />
                  {!iosOk && <small className="hint">Düzgün URL daxil edin</small>}
                </div>
              </>
            )}

            {isAppLink === false && (
              <div className="qrduz-row">
                <label>Əsas link</label>
                <input
                  type="url"
                  className={!mainOk ? 'invalid' : ''}
                  placeholder="https://example.com/path"
                  value={mainLink}
                  onChange={(e) => setMainLink(e.target.value)}
                />
                {!mainOk && <small className="hint">Düzgün URL daxil edin</small>}
              </div>
            )}

            {/* Metadata */}
            {(initial?.createdAt || initial?.updatedAt) && (
              <div className="qrduz-meta">
                {initial?.createdAt && (
                  <div><strong>Yaradıldı:</strong> {initial.createdAt}</div>
                )}
                {initial?.updatedAt && (
                  <div><strong>Son yenilənmə:</strong> {initial.updatedAt}</div>
                )}
              </div>
            )}

            <div className="qrduz-actions">
              <button
                className="save-button"
                onClick={handleSave}
                disabled={!canSave || loading}
              >Yadda saxla</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

